import { render, staticRenderFns } from "./purchaseReceivingTask.vue?vue&type=template&id=62a8d799&scoped=true"
import script from "./purchaseReceivingTask.vue?vue&type=script&lang=js"
export * from "./purchaseReceivingTask.vue?vue&type=script&lang=js"
import style0 from "./purchaseReceivingTask.vue?vue&type=style&index=0&id=62a8d799&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a8d799",
  null
  
)

export default component.exports